module.exports = __webpack_public_path__ + "static/media/Montenegro.e905d5db.png";